/**
 * GeChiUI dependencies
 */
import { Component } from '@gechiui/element';

export class RichTextShortcut extends Component {
	render() {
		return null;
	}
}
